import Swal from 'sweetalert2';

function ErrorAlert(message, title, icon, time) {
 let timeNow = time
  if(title === undefined || message === undefined || icon === undefined){
    message = "Ocurrio un error."
    title = "Error!"
    icon = 'error'
  }

  if(time === undefined){
    time = 5000
  }
  console.log(message, title, icon, time)
  return (
        //We show a error alert 
        Swal.fire({
            icon: icon,
            title: title, //mensaje en pantalla
            text: message,
            showConfirmButton: true,
            timer: timeNow
        })
  )
}

export default ErrorAlert